import { c as _c } from "react/compiler-runtime";
import { useProduct } from "@/queries/useProduct";
import { usePdpStore } from "@/stores/usePdpStore";
import { PackagingMode, resolvePackagingMode } from "@/utils/resolvePackagingMode";
import { useProductBuilderContext } from "./ProductBuilderContext";
import RollQuantityField from "./RollQuantityField";
export const PackagingQuantity = () => {
  const $ = _c(4);
  const {
    product
  } = useProductBuilderContext();
  const {
    data: productAdmin
  } = useProduct(product.sku);
  const selectedFinish = usePdpStore(_temp);
  const resolvedFinish = selectedFinish ?? productAdmin?.defaultFinishing;
  let t0;
  if ($[0] !== resolvedFinish) {
    t0 = resolvePackagingMode(resolvedFinish);
    $[0] = resolvedFinish;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const packagingMode = t0;
  let t1;
  if ($[2] !== packagingMode) {
    t1 = packagingMode === PackagingMode.Roll && <RollQuantityField />;
    $[2] = packagingMode;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
function _temp(state) {
  return state.finish;
}